import { Store } from "redux";
import { SDK } from "@sdk";
import { iStore } from "../../store.model";
import { CreateHelpersForEntity } from "../../utils/entity-slice-creator";
import { LedgersSlice } from "./ledgers.slice";
import { iLedger } from "@sdk/ledgers/ledgers-models";
import { ledgersDefaultQueryConfig, LEDGERS_PAGE_SIZE } from "./ledgers-default-query";

export { LEDGERS_PAGE_SIZE };

export const {
  loadEntityQueries: loadLedgersQuery,
  loadEntityById: loadLedgerById,
  loadMoreEntityQueries: loadMoreLedgersQueries,
} = CreateHelpersForEntity<iStore, iLedger>({
  sliceName: "ledgers",
  slice: LedgersSlice,
  isPaginatedQueries: true,
  fetchPageSize: LEDGERS_PAGE_SIZE,
  loadEntityQueryProvider: (query) => SDK.ledgers.query(query),
  loadEntityByIdProvider: (entityId: string) => SDK.ledgers.getById(entityId),
});

/** Loads every ledger page until the query list matches totalItems. */
export const LoadAllLedgers = async (
  store: Store<iStore>,
  forceReload?: boolean
) => {
  await loadLedgersQuery(ledgersDefaultQueryConfig, "all")(store, forceReload);

  let queryState = store.getState().ledgers.queries.all;
  while (queryState && !queryState.hasError) {
    const totalItems = queryState.totalItems ?? 0;
    const loadedCount = queryState.list?.length ?? 0;

    if (totalItems === 0 || loadedCount >= totalItems) {
      break;
    }

    const previousLoadedCount = loadedCount;
    await loadMoreLedgersQueries(ledgersDefaultQueryConfig, "all")(store);
    queryState = store.getState().ledgers.queries.all;

    if ((queryState?.list?.length ?? 0) === previousLoadedCount) {
      break;
    }
  }
};

